import { render, staticRenderFns } from "./UserAssigments.vue?vue&type=template&id=b8d66102&scoped=true"
import script from "./UserAssigments.vue?vue&type=script&lang=js"
export * from "./UserAssigments.vue?vue&type=script&lang=js"
import style0 from "./UserAssigments.vue?vue&type=style&index=0&id=b8d66102&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d66102",
  null
  
)

export default component.exports